
import Vue from 'vue';
import { faCircleExclamation, faXmark } from '@delfi.lt/fa-kit/icons/modules/classic/regular';
import { IconDefinition } from '@delfi.lt/fa-kit/icons/modules/icon-types';

interface Props {
  title: string;
  message: string;
  icon: IconDefinition;
  closable: boolean;
}

export default Vue.extend<unknown, unknown, unknown, Props>({
  props: {
    title: {
      type: String,
      default: '',
    },
    message: {
      type: String,
      default: '',
    },
    icon: {
      type: Object as () => Props['icon'],
      default: faCircleExclamation,
    },
    closable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      faXmark,
    };
  },
});
